// Utility References
import { ExceptionHelper } from 'Utility/IndexOfHelpers';
import { IApiException, IApiExceptionGroup, IGenericDictionary } from 'Utility/IndexOfInterfaces';
import { Notification } from 'Utility/IndexOfServices';

const Exception = ExceptionHelper.ApiException;

interface IChangePasswordExceptions extends IGenericDictionary<IApiException> {
    OldPasswordInvalid: IApiException;
    ResetPasswordIdentical: IApiException;
}

const exceptions: IChangePasswordExceptions = {
    OldPasswordInvalid: Exception('The current password you entered was incorrect, please enter it again', Notification.error.handledException),
    ResetPasswordIdentical: Exception('Your new password cannot be the same as your old password, please choose something different.', Notification.error.handledException)
};

const exceptionGroup: IApiExceptionGroup = {
    area: 'ChangePassword',
    exceptions
};

export {
    exceptionGroup as ChangePasswordExceptionGroup,
    exceptions as ChangePasswordExceptions
};
